import Stack from '@mui/material/Stack';
import SectionTitle from './SectionTitle';

const CARD_COLOR_VARIANTS = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  DISABLED: 'disabled',
};

const CARD_COLOR_VARIANTS_MAP = {
  [CARD_COLOR_VARIANTS.DEFAULT]: 'background.default',
  [CARD_COLOR_VARIANTS.PRIMARY]: 'header.main',
  // styled black 20% opacity
  [CARD_COLOR_VARIANTS.DISABLED]: 'grey.400',
};

const CARD_BORDER_VARIANTS = {
  DEFAULT: 'default',
  OUTLINED: 'outlined',
};

/**
 * Card component
 * @param {Object} props
 * @param {string} [props.title]
 * @param {'subtitle' | 'title'} [props.titleVariant='subtitle']
 * @param {React.ReactNode} [props.action]
 * @param {React.ReactNode} props.children
 * @param {'default' | 'primary' | 'disabled'} [props.colorVariant='default']
 * @param {'default' | 'outlined'} [props.borderVariant='default']
 * @param {Object} [props.sx]
 * @returns {JSX.Element}
 */
export default function Card({
  title,
  titleVariant = 'subtitle',
  action,
  children,
  colorVariant = 'default',
  borderVariant = 'outlined',
  sx = {},
}: {
  title?: any;
  titleVariant?: string;
  action?: any;
  children?: any;
  colorVariant?: string;
  borderVariant?: string;
  sx?: any;
  [key: string]: any;
}) {
  return (
    <Stack
      direction='column'
      gap={3}
      sx={{
        px: 2,
        py: 3,
        bgcolor: CARD_COLOR_VARIANTS_MAP[colorVariant] || 'background.default',
        border: borderVariant === CARD_BORDER_VARIANTS.OUTLINED ? '1px solid' : 'none',
        borderColor: borderVariant === CARD_BORDER_VARIANTS.OUTLINED ? 'grey.300' : 'transparent',
        borderRadius: borderVariant === CARD_BORDER_VARIANTS.OUTLINED ? 2 : 0,
        ...sx,
      }}
    >
      {(title || action) && (
        <div className='row row--between'>
          <div>{title && <SectionTitle title={title} variant={titleVariant} />}</div>
          {action}
        </div>
      )}
      <div className='column'>{children}</div>
    </Stack>
  );
}
